import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { configuracionFormAction25, obtenerDatosImplicado } from '../../store/actions/carta-cia-action'
import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'
import CartaCIA from './CartaCIA'
import { LoadingComponent } from 'recupero-comunes'
const CartaCiaModal = ({ handleClose, idCaso,idImplicado,idOrganizacionCaso }) => {
    const [loading, setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves} = data_recepciona
   const dispatch=useDispatch()
    
    useEffect(() => {     

        dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
      
      }, [dispatch])
      useEffect(() => {
      if(llaves) {
        setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 25
        })).toString('base64')
        dispatch(configuracionFormAction25(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idImplicado": llaves && llaves['idImplicado'],
                "idCaso": llaves && llaves['idCaso']
            })).toString('base64')
            dispatch(obtenerDatosImplicado(query))
        })
        .then(()=>{
            setLoading(false)
        })
    }
    }, [dispatch,llaves])
 
 
      
      
    
    
    return (
        <>
        <LoadingComponent show={loading}/>
            <CartaCIA 
                handleClose={handleClose}
                />
        </>
    )
}

export default CartaCiaModal
